import React from 'react';
import styles from './styles.module.scss';

export interface TieCardSide {
  /** Team name, or the text that says who takes the side. */
  label: string;
  logoUrl: string | null;
  /** Goals over the tie; `null` before the first score. */
  score: number | null;
  isEliminated: boolean;
}

export interface TieCardProps {
  /** Header line saying what the numbers are; omitted when `null`. */
  caption: string | null;
  sides: [TieCardSide, TieCardSide];
  /** The teams are not known yet: dashed outline, no logos. */
  isPlaceholder?: boolean;
  /** The larger card of the final. */
  isFinal?: boolean;
}

/**
 * One tie of a play-off bracket: both teams and one number each. The legs are
 * not listed and the card is not a link.
 */
export const TieCard: React.FC<TieCardProps> = ({ caption, sides, isPlaceholder = false, isFinal = false }) => (
  <div
    className={[styles.card, isPlaceholder ? styles.placeholder : null, isFinal ? styles.final : null]
      .filter(Boolean)
      .join(' ')}
    role="group"
    aria-label={`${sides[0].label} - ${sides[1].label}`}
    data-testid="bracket-tie"
  >
    {caption && <span className={styles.caption}>{caption}</span>}
    {sides.map((side, index) => (
      <span key={index} className={`${styles.row} ${side.isEliminated ? styles.eliminated : ''}`}>
        {!isPlaceholder &&
          (side.logoUrl ? (
            <img className={styles.logo} src={side.logoUrl} alt="" width={22} height={22} decoding="async" />
          ) : (
            <span className={styles.logo} />
          ))}
        <span className={styles.name}>{side.label}</span>
        {side.score !== null && <span className={styles.score}>{side.score}</span>}
      </span>
    ))}
  </div>
);

export default TieCard;
